import { Col, Container, Row } from "reactstrap"

const PhaseLayout = ({ top, bottom }) => {

    return (
        <Container fluid={true} className="phase-container">
            <Row className="checklist-row">
                <Col md="12" className="phase-col">
                    {top}
                </Col>
            </Row>
            <Row className="patient-status-row">
                <Col md="12" className="patient-status-col">
                    {bottom}
                </Col>
            </Row>
        </Container>
    )
}

export default PhaseLayout